import { csx } from '@vtex/admin-ui'

export const filterGroup = csx({
  gap: '$space-2',
  '& > button': {
    marginLeft: '0 !important',
  },
})
